<script setup lang="ts">
  defineOptions({ name: 'CPDivider', inheritAttrs: false })

  // External library imports
  import { HLDivider } from '@platform-ui/highrise'

  // Props definitions
  const props = defineProps({
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    marginTop: {
      type: String,
      required: false,
      default: '16px',
    },
    marginBottom: {
      type: String,
      required: false,
      default: '16px',
    },
    color: {
      type: String,
      required: false,
      default: '--cp-border-500',
    },
  })

  const dividerMarginStyles = computed(() => {
    return {
      '--n-divider-margin': props.marginTop + ' 0px ' + props.marginBottom + ' 0px',
      '--n-color': 'var(' + props.color + ')',
    }
  })
</script>

<template>
  <HLDivider v-bind="$attrs" :id="props.id" :class="props.className" class="cp-divider" :style="dividerMarginStyles">
    <slot />
  </HLDivider>
</template>

<style></style>
